'use strict';
import angular from 'angular';
import './scripts/ioclients.ctrls';
import './scripts/ioclients.services';

import clientsHtmlUrl from './views/clients.html';
import addClientHtmlUrl from './views/addClient.html';
import clientViewHtmlUrl from './views/clientView.html';
import clientCreativesViewHtmlUrl from './views/clientCreativesView.html';

angular.module('ioclients', [
    'ioclients.ctrls',
    'ioclients.services'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('ioclients', {
                parent: 'layout',
                url: '/admin/ioclients',
                templateUrl: clientsHtmlUrl,
                controller: 'ClientsController'
            })
            .state('addClient', {
                parent: 'layout',
                url: '/admin/ioclients/add',
                templateUrl: addClientHtmlUrl,
                controller: 'AddClientController'
            })
            .state('editClient', {
                parent: 'layout',
                url: '/admin/ioclients/edit/:id',
                templateUrl: addClientHtmlUrl,
                controller: 'AddClientController',
                params: {
                    client: null
                }
            })
            .state('viewClient', {
                parent: 'layout',
                url: '/admin/ioclients/:id',
                templateUrl: clientViewHtmlUrl,
                controller: 'ClientViewController',
                params: {
                    client: null
                }
            })
            .state('viewCreatives', {
                parent: 'layout',
                url: '/admin/ioclientCreatives/:id',
                templateUrl: clientCreativesViewHtmlUrl,
                controller: 'ClientCreativesViewController',
                params: {
                    client: null
                }
            })

    }]);